import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { logo2 } from '../../Data/Images/Home';
import {
  RecentPost,
  UsefulLinks,
  StayConnected,
  About,
  TermsConditions,
  Policy,
  FAQs,
  Blogs,
  ContactUs_,
  Partner,
  Practitioner,
  TakeTheTest,
} from '../../Constants';
import { useGetBlogsQuery } from '../../features/blogApiSlice';
import { useSelector } from 'react-redux';
import { selectSlug } from '../../features/contentsSlice';
import PaymentMethods from '../../assets/payment-methods.webp';
import Shipping from '../../assets/shipping-DHL.webp';
import Reviews from '../../assets/reviews.webp';
import CustomLink from '../../Components/CustomLink';
import useMeta from '../../hooks/useMeta';

const Footer = () => {
  const lang = 'en';
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const slug = useSelector(selectSlug);

  const { data: fetchBlogs, isSuccess } = useGetBlogsQuery({
    lang: lang,
    page: 1,
    rows: 3,
    category: 'blog',
  });

  useEffect(() => {
    if (isSuccess) {
      setData(fetchBlogs.data);
    }
  }, [fetchBlogs]);

  const { metaEvent } = useMeta();

  return (
    <Fragment>
      <footer className="t-py-8">
        <div className="container">
          <div className="row gy-3 gx-sm-4">
            <div className="col-lg-4">
              <div className="logo">
                <img src={logo2} alt="riise logo 2" className="img-fluid" width={120} />
              </div>
              <div className="mt-5">
                <CustomLink to="/quiz">
                  <span className="btn btn-custom-tertiary !t-rounded-lg t-font-sans">{t(TakeTheTest)}</span>
                </CustomLink>
              </div>
              {/*<h4>{t(SubscribeFirstPurchase)}</h4>*/}
              {/*<form>*/}
              {/*  <div className="mb-3">*/}
              {/*    /!* <label for="" class="form-label">Name</label> *!/*/}
              {/*    <input*/}
              {/*        type="text"*/}
              {/*        onChange={(e) => setEmail(e.target.value)}*/}
              {/*        className="form-control" placeholder={t(EnterEmailHere)} aria-describedby="helpId" />*/}
              {/*    {emailError === '' ? '' : <span className="text-danger">{emailError}</span>}*/}
              {/*    {emailMessage === '' ? '' : <span className="text-success">{emailMessage}</span>}*/}
              {/*  </div>*/}
              {/*  <button type="button" className="btn btn-custom w-100" onClick={handleSubscribe}>{t(SubscribeNow)}</button>*/}
              {/*</form>*/}
            </div>
            {/* <div className="col-lg-3">
              <div className="footer-item">
                <h3 className="title2">{t(RecentPost)}</h3>
                {data.map((blog, index) => (
                  <a key={index} href={`${process.env.PUBLIC_URL}/blogs/${blog.slug}`}>
                    <div className="recent-blog-item">
                      <div className="">
                        <img
                          src={`${process.env.REACT_APP_PUBLIC_URL}${blog.picture}`}
                          alt={blog.title || 'Blog picture'}
                          width={96}
                        />
                      </div>
                      <div>
                        <p>{blog.contents.substring(0, 50)}</p>
                        <h6>{blog.bdate}</h6>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div> */}
            <div className="col-lg-4">
              <div className="footer-item">
                <h3 className="title2 !t-font-sans t-font-normal t-text-sm">{t(UsefulLinks)}</h3>
                <ul className="useful-links t-flex t-flex-col t-gap-1">
                  <CustomLink
                    to="/about"
                    className="t-font-sans t-text-sm !t-text-black t-font-normal"
                    onClick={() => metaEvent('ViewContent')}
                  >
                    {t(About)}
                  </CustomLink>
                  <CustomLink to="/referral" className="t-font-sans t-text-sm !t-text-black t-font-normal">
                    {t('Footer_ReferAFriend')}
                  </CustomLink>
                  <CustomLink to="/impressum" className="t-font-sans t-text-sm !t-text-black t-font-normal">
                    Impressum
                  </CustomLink>
                  <CustomLink to="/legal" className="t-font-sans t-text-sm !t-text-black t-font-normal">
                    {t(TermsConditions)}
                  </CustomLink>
                  <CustomLink to="/policy" className="t-font-sans t-text-sm !t-text-black t-font-normal">
                    {t(Policy)}
                  </CustomLink>
                  <CustomLink to="/faqs" className="t-font-sans t-text-sm !t-text-black t-font-normal">
                    {t(FAQs)}
                  </CustomLink>
                  <CustomLink to="/blogs" className="t-font-sans t-text-sm !t-text-black t-font-normal">
                    {t(Blogs)}
                  </CustomLink>
                  <CustomLink
                    to="/contactus"
                    className="t-font-sans t-text-sm !t-text-black t-font-normal"
                    onClick={() => metaEvent('Contact')}
                  >
                    {t(ContactUs_)}
                  </CustomLink>
                  <CustomLink to="/partner" className="t-font-sans t-text-sm !t-text-black t-font-normal">
                    {t(Partner)}
                  </CustomLink>
                  <a href="https://riise-partner.weriise.co/practitioner/" className="t-font-sans t-text-sm !t-text-black t-font-normal">
                    {t(Practitioner)}
                  </a>
                </ul>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="footer-item">
                <h3 className="title2 !t-font-sans t-font-normal t-text-sm">{t(StayConnected)}</h3>
                <ul className="social">
                  <li>
                    <a href="https://www.instagram.com/we_riise/" target="_blank" rel="noreferrer">
                      <i className="fab fa-instagram" />
                    </a>
                  </li>
                  {/*<li><a href><i className="fab fa-twitter" /></a></li>*/}
                  {/*<li><a href><i className="fab fa-facebook-f" /></a></li>*/}
                  {/*<li><a href><i className="fab fa-youtube" /></a></li>*/}
                </ul>

                <img src={PaymentMethods} alt="" className="img-fluid mt-4 t-w-[50%] md:t-w-[70%]" />
                <img src={Shipping} alt="" className="img-fluid mt-4 t-w-1/3 md:t-w-1/3" />
                <img src={Reviews} alt="" className="img-fluid mt-4 t-w-1/3 md:t-w-1/2" />
              </div>
            </div>
          </div>
        </div>
      </footer>
    </Fragment>
  );
};

export default Footer;
